import { adminDashboardRouteConfig } from './routes/admin-dashboard-routes';
import { avonPatientRouteConfig } from './routes/avon-patient.routes';
import { callsPageRouteConfig } from './routes/calls-page.routes';
import { docketRouteConfig } from './routes/docket.routes';
import { guideListPageRouteConfig } from './routes/guide-list.routes';
import { hospitalizationRouteConfig } from './routes/hospitalization.routes';
import { loginPageRouteConfig } from './routes/login.routes';
import { memberDetailsRouteConfig } from './routes/member-details.routes';
import { memberListRouteConfig } from './routes/member-list.routes';
import { memberPageRouteConfig } from './routes/member-page.routes';
import { noAccessPageRouteConfig } from './routes/no-access.routes';
import { trainingAdminPageRouteConfig } from './routes/training-admin.routes';

export const useAppNavigation = () => ({
  ...docketRouteConfig.useNavigationHooks(),
  ...memberListRouteConfig.useNavigationHooks(),
  ...memberPageRouteConfig.useNavigationHooks(),
  ...callsPageRouteConfig.useNavigationHooks(),
  ...guideListPageRouteConfig.useNavigationHooks(),
  ...trainingAdminPageRouteConfig.useNavigationHooks(),
  ...loginPageRouteConfig.useNavigationHooks(),
  ...avonPatientRouteConfig.useNavigationHooks(),
  ...adminDashboardRouteConfig.useNavigationHooks(),
  ...hospitalizationRouteConfig.useNavigationHooks(),
  ...noAccessPageRouteConfig.useNavigationHooks(),
  ...memberDetailsRouteConfig.useNavigationHooks(),
});
